export enum EmpresaTipoEnum {
    NORMAL = 1,
    ACESSO_GERAL = 2,
    DESENVOLVEDORES = 3,
}